const SubscribeForm = () => {
  return (
    <div>
      <h1>Subscribe to our newsletter</h1>
      <form>
        <input type="text" placeholder="Enter your email" />
        <button>Subscribe</button>
      </form>
    </div>
  );
};

export default SubscribeForm;
